var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-col',{staticClass:"p-3 m-3",attrs:{"cols":"12","md":"4","lg":"3"}},[_c('div',{staticClass:"skill-set-square-btn position-relative pointer d-flex align-items-center justify-content-center flex-column",class:{
      pointer: _vm.selected !== _vm.index && _vm.skill.title.length,
      cluster: _vm.selected === _vm.index,
    },style:({
      background: `url(${_vm.getBackground(_vm.skill.background)})`,
    }),on:{"click":function($event){!_vm.selected !== _vm.index && _vm.skill.title.length
        ? _vm.$emit('select', _vm.index)
        : null}}},[_c('h5',{key:_vm.skill.title,domProps:{"innerHTML":_vm._s(_vm.skill.little)}}),(_vm.skill.title.length)?_c('small',{staticClass:"text-secondary"},[_vm._v(_vm._s(_vm.$t("Click to Open")))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }